// src/ui/WobbleCard.js
"use client";
import { cn } from "../lib/cn";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { useRef } from "react";

export function WobbleCard({
  children,
  containerClassName,
  className,
  imageSrc,
  bgColor = "bg-gradient-to-r from-blue-500 to-indigo-600", // default gradient if none provided
}) {
  const ref = useRef(null);

  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const smoothMouseX = useSpring(mouseX, { stiffness: 50, damping: 10 });
  const smoothMouseY = useSpring(mouseY, { stiffness: 50, damping: 10 });

  const rotateX = useTransform(smoothMouseY, [-0.5, 0.5], ["15deg", "-15deg"]);
  const rotateY = useTransform(smoothMouseX, [-0.5, 0.5], ["-15deg", "15deg"]);

  function handleMouseMove(event) {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;

    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const newX = (x / width) * 2 - 1;
    const newY = (y / height) * 2 - 1;

    mouseX.set(newX);
    mouseY.set(newY);
  }
  
  console.log("WobbleCard imageSrc:", imageSrc); // ADD THIS LINE

  return (
    <motion.div
      ref={ref}
      style={{ perspective: 1000 }}
      className={cn("relative group w-full h-full", containerClassName)}
      onMouseMove={handleMouseMove}
      onMouseLeave={() => {
        mouseX.set(0);
        mouseY.set(0);
      }}
    >
      <motion.div
        style={{ rotateX, rotateY }}
        className={cn(
          "relative w-full h-full rounded-xl shadow-lg p-6 text-white transition-transform duration-300 ease-out",
          bgColor,
          className
        )}
      >
        {/* Optional image overlay */}
        {imageSrc && (
          <img
            src={imageSrc} // Set the src attribute to the imageSrc prop
            alt=""
            className="absolute top-0 right-0 w-full h-full object-cover rounded-xl opacity-30 pointer-events-none"
          />
        )}
        {children}
      </motion.div>
    </motion.div>
  );
}
